import React, { Fragment, useEffect, useState } from 'react';
import {
  Row,
  CardBody,
  Card,
  Button,
  ButtonGroup,
  CustomInput,
  Input,
  Label,
} from 'reactstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import {
  Separator,
  Colxx,
} from '../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import Languages from '../../../../../data/languages';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import {
  API_OpenAI_Assistant,
  gAPI_QuestionSets,
} from '../../../../../constants/APIs';
import { faTruckFieldUn } from '@fortawesome/free-solid-svg-icons';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
import Select from 'react-select';
import { useSelector } from 'react-redux';
function ChatbotFeatures({
  botSettings,
  saveIntegration,
  integration,
  integrationProperties,
  locale,
  allProperties,
  channel,
}) {
  const propertyId = useSelector((state) => state?.settings?.propertyId);
  const [propetyAssistants, setPropertyAssistant] = useState([]);
  const [featuresList, setFeaturesList] = useState([]);
  const [formatedProperties, setFormatedProperties] = useState([]);
  const [features, setFeatures] = useState(botSettings.features);
  const [languageGPT3, setLanguageGPT3] = useState([]);
  const [assistantList, setAssistantList] = useState([]);

  const [aiAssistant, setAIAssistant] = useState(
    features?.openAIAssistant?.assistantId
      ? features.openAIAssistant?.assistantId
      : ''
  );

  const [languageInstructions, setLanguageInstructions] = useState(
    botSettings?.languageInstructions !== null &&
      botSettings?.languageInstructions !== undefined
      ? botSettings?.languageInstructions
      : ''
  );

  const [imageInstructions, setImageInstructions] = useState(
    botSettings?.imageInstructions !== null &&
      botSettings?.imageInstructions !== undefined
      ? botSettings?.imageInstructions
      : ''
  );

  const [selectedProperty, setSelectedProperty] = useState(
    integrationProperties.length > 0 ? integrationProperties[0] : ''
  );

  useEffect(() => {
    const result = integrationProperties.map((id) => {
      return [...allProperties].find((elem) => elem.id === id);
    });
    setFormatedProperties(result);
  }, [integrationProperties, allProperties]);

  const handleChange = (event) => {
    setSelectedProperty(event.target.value);
  };
  //by default Gpt version
  useEffect(() => {
    if (features.generativeGPT3 && !features.versionGPT3) {
      setFeatures((prev) => ({ ...prev, versionGPT3: '7' }));
    }
  }, [features.generativeGPT3]);


  useEffect(() => {
    if (!allProperties?.length) return;

    let assistants = [];

    const loadFlows = async () => {
      const requests = [...allProperties].map(async (p) => {
        return AxiosAPI({
          methed: 'get',
          url: `${gAPI_QuestionSets}/?propertyId=${p.id}&groupId=${getGroupID()}&lang=${locale}`,
        }).then((res) => {
          const sets =
            res.data.sets?.sort((a, b) => a.displayOrder - b.displayOrder) ||
            [];

          const flows = sets.filter(
            (l) =>
              l.type === 'DynamicConversationFlow' && l.openAiAssistantId !== ''
          );
          if (flows.length > 0)
            flows.map((l) => {
              assistants.push({
                id: l.openAiAssistantId,
                name: l.name,
                pid: p.id === '-1' ? getGroupID() : p.id,
                pname: p.name,
                isGroupLevel: l?.isGroupVisible ?? false,
              });
            });
          else
            assistants.push({
              id: '',
              name: '',
              pid: p.id === '-1' ? getGroupID() : p.id,
              pname: p.name,
            });
        });
      });

      await Promise.all(requests);
      setPropertyAssistant(assistants);
    };

    loadFlows();
  }, [allProperties]);

  useEffect(() => {
    if (selectedProperty) {
      loadResponse();
    }
  }, [selectedProperty]);

  const handleCheckedSerach = (e) => {
    var feat = { ...features };
    feat.predictiveSearch = e;
    setFeatures(feat);
    botSettings.features = feat;
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true
          ? 'Predictive search enabled successfully'
          : 'Predictive search disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: botSettings });
  };
  const handleCheckedUpsells = (e) => {
    var feat = { ...features };
    feat.addOnUpsells = e;
    setFeatures(feat);
    botSettings.features = feat;
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true
          ? 'Add-on`s & upsells enabled successfully'
          : 'Add-on`s & upsells disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: botSettings });
  };

  const handleAutoLanguageDetection = (e) => {
    var feat = { ...features };
    feat.autoLanguageDetection = e;
    setFeatures(feat);
    botSettings.features = feat;
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true
          ? 'Auto language detection enabled successfully'
          : 'Auto language detection disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: botSettings });
  };

  // openAI

  const loadResponse = async () => {
    return await AxiosAPI({
      methed: 'get',
      url: `${gAPI_QuestionSets}/?propertyId=${selectedProperty}&groupId=${getGroupID()}&lang=${locale}`,
    })
      .then((res) => {
        var setslist = res.data.sets.sort(
          (a, b) => a.displayOrder - b.displayOrder
        );
        var list = [];
        if (setslist !== null && setslist.length > 0) {
          setslist
            .filter(
              (l) =>
                l.type === 'DynamicConversationFlow' &&
                l.openAiAssistantId !== ''
            )
            .map((l) => {
              list.push({ id: l.openAiAssistantId, name: l.name });
            });
        }

        setAssistantList(list);
      })
      .catch((err) => {
        console.error(
          'API error:',
          err.response ? err.response.data : err.message
        );
      });
  };

  //e.o.OpenAI
  const handleCheckedOpenAIEnabled = (e) => {
    const feat = { ...features };
    feat.fixedResponses = e === true ? false : true;
    feat.generativeGPT3 = false;
    feat.liveChatOnly = e === true ? false : true;
    var openai = { ...feat.openAIAssistant };
    openai.isEnabled = e;
    openai.versionDynamicFlow = e ? '6DynamicConverstionFlow' : '';

    feat.openAIAssistant = openai;
    setFeatures(feat);
  };
  // const handleCheckedOpenAIEnabled = (e) => {
  //   var feat = { ...features };
  //   feat.fixedResponses = e === true ? false : true;
  //   feat.generativeGPT3 = false;
  //   feat.liveChatOnly = e === true ? false : true;
  //   var openai = { ...feat.openAIAssistant };
  //   openai.isEnabled = e;
  //   feat.openAIAssistant = openai;
  //   setFeatures(feat);
  // };
  const handleChangeAssistantId = (e) => {
    setAIAssistant(e.target.value);
    var feat = { ...features };
    var openai = { ...feat.openAIAssistant };
    openai.assistantId = e.target.value;
    feat.openAIAssistant = openai;
    setFeatures(feat);
  };

  // const handleVersionDynamicFlowChange = (e) => {
  //   var feat = { ...features };
  //   var openai = { ...feat.openAIAssistant };
  //   openai.versionDynamicFlow = e;
  //   feat.openAIAssistant = openai;
  //   setFeatures(feat);
  // };

  useEffect(() => {
    if (
      botSettings !== undefined &&
      botSettings?.featuresList !== undefined &&
      botSettings?.featuresList !== null
    ) {
      let lst = [];
      botSettings?.featuresList.map((m) => {
        let obj = {};
        let propertiesList = [];
        if (m?.properties !== undefined && m?.properties !== null) {
          m?.properties.map((p) => {
            [...allProperties].map((ap) => {
              if (ap.id === p) {
                propertiesList.push({ label: ap.name, value: ap.id });
              }
            });
          });
        }
        obj.languageGPT3 = m?.languageGPT3 || [];
        obj.properties = propertiesList;
        obj.languageInstructions = m?.languageInstructions || '';
        obj.imageInstructions = m?.imageInstructions || '';
        obj.autoLanguageDetection = m?.autoLanguageDetection || false;
        if (m?.imageRecognition?.isDynamicFlow) obj.imageRecognition = true;

        if (m?.openAIAssistant && m?.openAIAssistant?.isEnabled === true) {
          obj.nlpType = 'openAIAssistant';
        }
        if (m?.openAIAssistantList && m?.openAIAssistantList?.length > 0) {
          obj.nlpType = 'openAIAssistant';
          let openAIAssistantList = [];
          m?.openAIAssistantList.map((p) =>
            openAIAssistantList.push({
              isEnabled: true,
              propertyId: p.propertyId,
              versionDynamicFlow: '6DynamicConverstionFlow',
              assistantId: p.assistantId,
            })
          );
          obj.openAIAssistantList =
            m?.openAIAssistantList || openAIAssistantList;
        }

        if (m?.generativeGPT3 === true) {
          obj.nlpType = 'generativeGPT3';
          obj.verbosity = m?.verbosity || '';
          obj.versionGPT3 = m?.versionGPT3 || '';
        }
        if (m?.liveChatOnly === true) {
          obj.nlpType = 'liveChatOnly';
        }
        lst.push(obj);
        // if () {
        //   var intent = {};
        //   intent.isDynamicFlow = m?.imageRecognition?.isDynamicFlow || false;
        //   intent.isPreBuildTemplates = false;
        //   obj.intentRecognition = intent;
        // }
      });
      setFeaturesList(lst);
    }
  }, [allProperties]);

  const handleSave = () => {
    // features.reasoningEfforts = 'minimal';
    // botSettings.features = features;
    // botSettings.languageInstructions = languageInstructions;
    // botSettings.imageInstructions = imageInstructions;
    let lst = [];
    featuresList.map((m) => {
      let obj = {};
      obj.reasoningEfforts = 'minimal';
      obj.languageGPT3 = m?.languageGPT3;
      if (m?.nlpType === 'openAIAssistant') {
        let openai = {};
        openai.isEnabled = true;
        openai.versionDynamicFlow = '6DynamicConverstionFlow';
        openai.assistantId = m?.assistantId;
        obj.openAIAssistant = openai;
        obj.fixedResponses = false;
        obj.generativeGPT3 = false;
        obj.liveChatOnly = false;

        obj.openAIAssistantList = m?.openAIAssistantList || [];
      } else if (m?.nlpType === 'generativeGPT3') {
        obj.generativeGPT3 = true;
        obj.fixedResponses = false;
        obj.liveChatOnly = false;
        obj.verbosity = m?.verbosity;
        obj.versionGPT3 = m?.versionGPT3;
        let openai = {};
        openai.isEnabled = false;
        openai.versionDynamicFlow = '';
        openai.assistantId = '';
        openai.isEnabled = false;
        obj.openAIAssistant = openai;
      } else if (m?.nlpType === 'liveChatOnly') {
        obj.generativeGPT3 = false;
        obj.fixedResponses = false;
        obj.liveChatOnly = true;
        let openai = {};
        openai.isEnabled = false;
        openai.versionDynamicFlow = '';
        openai.assistantId = '';
        openai.isEnabled = false;
        obj.openAIAssistant = openai;
      }
      if (m?.imageRecognition === true) {
        var intent = {};
        intent.isDynamicFlow = true;
        intent.isPreBuildTemplates = false;
        obj.imageRecognition = intent;
      }
      if (m?.imageRecognition === true) {
        var intent = {};
        intent.isDynamicFlow = true;
        intent.isPreBuildTemplates = false;
        obj.intentRecognition = intent;
      }
      obj.languageInstructions = m?.languageInstructions || '';
      obj.imageInstructions = m?.imageInstructions || '';
      obj.properties = m?.properties.map((m) => m.value) || '';
      obj.autoLanguageDetection = m?.autoLanguageDetection || false;
      lst.push(obj);
    });
    botSettings.featuresList = lst;
    saveIntegration({ botSetting: botSettings });
  };

  const handleRemoveSettings = (index) => {
    let lst = [...featuresList];
    setFeaturesList(lst.filter((f, i) => i !== index));
  };

  const handleAddFeaturesList = () => {
    let lst = [...featuresList];
    lst.push({
      properties: [],
      liveChatOnly: false,
      generativeGPT3: false,
      openAIAssistant: { isEnabled: false },
      nlpType: '',
    });
    setFeaturesList(lst);
  };

  const handleFeatureListChange = (index, e) => {
    let lst = [...featuresList];
    lst[index][e.target.name] = e.target.value;
    setFeaturesList(lst);
  };

  const handleFeaturesNLPChange = (e, index) => {
    let lst = [...featuresList];
    lst[index][e.target.name] = e.target.value;
    if (e.target.value === 'openAIAssistant') {
      let openAIAssistantList = [];
      lst[index].properties.map((m) =>
        openAIAssistantList.push({
          isEnabled: true,
          propertyId: m.value,
          versionDynamicFlow: '6DynamicConverstionFlow',
          assistantId: '',
        })
      );
      lst[index].openAIAssistantList = openAIAssistantList;
    }
    setFeaturesList(lst);
  };

  const handleFeaturesImageChange = (e, index) => {
    let lst = [...featuresList];
    lst[index].imageRecognition = e;
    setFeaturesList(lst);
  };

  const handleFeaturesLanguageChange = (e, index) => {
    let lst = [...featuresList];
    lst[index].autoLanguageDetection = e;
    setFeaturesList(lst);
  };

  const handleLanguageChange = (index, e) => {
    console.error(index, 493, e.target.value);
    let lst = [...featuresList];
    console.error(index, 493, lst[index]);
    if (lst[index].languageGPT3.includes(e.target.value))
      lst[index].languageGPT3 = lst[index].languageGPT3.filter((elem) => elem !== e.target.value);
    else
      lst[index].languageGPT3.push(e.target.value);
    console.error(index, 493, lst[index]);
    setFeaturesList(lst);
  };

  const handleFeatureListProperties = (e, index) => {
    let lst = [...featuresList];
    lst[index].properties = e;
    let openAIAssistantList = [];
    if (lst[index]?.nlpType === 'openAIAssistant' && e.length > 0) {
      e.map((p) => {
        let obj = lst[index].openAIAssistantList.filter(
          (f) => p.value !== f.propertyId
        )?.[0];
        if (obj !== undefined)
          openAIAssistantList.push({
            isEnabled: true,
            propertyId: p.value,
            versionDynamicFlow: '6DynamicConverstionFlow',
            assistantId: obj.assistantId,
          });
        else
          openAIAssistantList.push({
            isEnabled: true,
            propertyId: p.value,
            versionDynamicFlow: '6DynamicConverstionFlow',
            assistantId: '',
          });
      });
      lst[index].openAIAssistantList = openAIAssistantList;
    }
    setFeaturesList(lst);
  };

  const handleRecentProperties = (lst) => {
    let lstProperties = [...featuresList].map((m) => m.properties);
    return lst.filter(
      (f) =>
        lstProperties
          .map((m) => m.map((i) => i.value))
          .flat()
          .filter((p) => p === f.id).length === 0
    );
  };

  const handleOpenAIAssistant = (e, v, i) => {
    let lst = [...featuresList];
    lst[v].openAIAssistantList[i][e.target.name] = e.target.value;
    setFeaturesList(lst);
  };

  // console.error('featuresList________mk',{featuresList,propetyAssistants})

  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <div className="text-center mb-2">
            <h6>AI Features & Language Settings </h6>
            <p>
              This section helps you decide how your AI talks with guests. You
              can choose the style of conversation and turn on auto language
              detection so every guest feels understood and welcomed.
            </p>
          </div>
          <Separator className="mb-3" />
          <Card className="m-4 p-4">
            <Colxx xxs="12" className="px-0">
              <div className="mb-2">
                {integration === undefined && (
                  <Card className="my-3">
                    <Colxx xxs="12" className="py-2">
                      <div className="">
                        <div className="row mt-1 ml-2 mb-1">
                          <div className="d-flex w-100">
                            <h6 style={{ marginTop: '0.15rem' }}>Predictive search</h6>
                            <Switch
                              className="agentswitch custom-switch-primary custom-switch-small ml-2"
                              checked={features.predictiveSearch}
                              name="predictiveSearch"
                              onChange={(e) => handleCheckedSerach(e)}
                            />
                          </div>
                          <div className="row ">
                            <span className="mx-3">
                              When enabled, user will see predictive suggestions as they
                              type the message
                            </span>
                          </div>
                        </div>
                      </div>
                    </Colxx>
                  </Card>
                )}
                {integration === undefined && (
                  <Card className="my-3">
                    <Colxx xxs="12" className="py-2">
                      <div className="">
                        <div className="row mt-1 ml-2 mb-1">
                          <div className="d-flex w-100">
                            <h6 style={{ marginTop: '0.15rem' }}>Add-on's & upsells</h6>
                            <Switch
                              className="agentswitch custom-switch-primary custom-switch-small ml-2"
                              checked={features.addOnUpsells}
                              name="enabled"
                              onChange={(e) => handleCheckedUpsells(e)}
                            />
                          </div>
                          <div className="row ">
                            <span className="mx-3">
                              When enabled, guests will be shown the Add-on and upsell
                              options available
                            </span>
                          </div>
                        </div>
                      </div>
                    </Colxx>
                  </Card>
                )}
                <Colxx xxs="12" className="mt-2 p-0">
                  {featuresList.length > 0 &&
                    featuresList.map((m, index) => (
                      <Fragment>
                        <Row className="my-2">
                          <Colxx md="12">
                            <Select
                              isMulti={true}
                              components={{ Input: CustomSelectInput }}
                              className="react-select"
                              classNamePrefix="react-select"
                              name="form-field-name"
                              options={handleRecentProperties([...allProperties]).map(
                                (x, i) => {
                                  return { label: x.name, value: x.id, key: x.id };
                                }
                              )}
                              value={m?.properties}
                              onChange={(val) =>
                                handleFeatureListProperties(val, index)
                              }
                            />
                          </Colxx>
                        </Row>
                        {m?.properties.length > 0 && (
                          <Fragment>
                            <Card className="my-3">
                              <Colxx xxs="12" className="py-3">
                                <div className="">
                                  <Row className="pb-2">
                                    <Colxx xxs="4">
                                      <b>NLP</b>
                                    </Colxx>
                                    <Colxx xxs="4">
                                      <b>Display Images</b>
                                    </Colxx>
                                    <Colxx xxs="4">
                                      <b>Auto Language Detection</b>
                                    </Colxx>
                                  </Row>
                                  <Row className="">
                                    {/* <Colxx md="3">
                                      <Select
                                        isMulti={true}
                                        components={{ Input: CustomSelectInput }}
                                        className="react-select"
                                        classNamePrefix="react-select"
                                        name="form-field-name"
                                        options={[
                                          { id: getGroupID(), name: 'Default' },
                                          ...allProperties,
                                        ]
                                          .filter(
                                            (f) =>
                                              featuresList.filter(
                                                (i) => !i.properties.includes(f.id)
                                              ).length > 0
                                          )
                                          .map((x, i) => {
                                            return { label: x.name, value: x.id, key: x.id };
                                          })}
                                        value={m?.properties}
                                        onChange={(val) =>
                                          handleFeatureListProperties(val, index)
                                        }
                                      />
                                    </Colxx> */}
                                    <Colxx md="4">
                                      <Input
                                        type="select"
                                        value={m?.nlpType}
                                        name="nlpType"
                                        onChange={(event) =>
                                          handleFeaturesNLPChange(event, index)
                                        }
                                      >
                                        <option value="">Select NLP</option>
                                        <option value={'liveChatOnly'}>
                                          Live Chat Only (No AI)
                                        </option>
                                        <option value={'generativeGPT3'}>Gen AI</option>
                                        <option value={'openAIAssistant'}>
                                          Dynamic Conversation Flow
                                        </option>
                                      </Input>
                                    </Colxx>
                                    <Colxx md="4">
                                      <Switch
                                        className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                        checked={m?.imageRecognition}
                                        name="imageRecognition"
                                        onChange={(e) =>
                                          handleFeaturesImageChange(e, index)
                                        }
                                      />
                                    </Colxx>
                                    <Colxx xxs="4">
                                      <Switch
                                        className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                        checked={m.autoLanguageDetection}
                                        name="autoLanguageDetection"
                                        onChange={(e) =>
                                          handleFeaturesLanguageChange(e, index)
                                        }
                                      />
                                    </Colxx>
                                  </Row>
                                </div>
                              </Colxx>
                            </Card>
                            <Row className="">
                              {m?.properties &&
                                m?.properties.length > 0 &&
                                m?.nlpType === 'generativeGPT3' && (
                                  <Fragment>
                                    <Card className="mb-3 mx-3">
                                      <Colxx xxs="12" className="py-2 px-0">
                                        <div className="">
                                          <Colxx xxs="12" className="my-2">
                                            Gen AI excels at answering questions by using your Knowledge Hub 
                                            to provide accurate and relevant information.
                                          </Colxx>
                                          <Colxx md="7" className="my-2">
                                            <Input
                                              type="select"
                                              name="versionGPT3"
                                              value={m?.versionGPT3}
                                              onChange={(e) =>
                                                handleFeaturesNLPChange(e, index)
                                              }
                                              className="mt-1"
                                            >
                                              <option value="">Select Version</option>
                                              <option value="6">
                                                Version 6 (GPT-4o-mini)
                                              </option>
                                              <option value="7">
                                                Version 7 (GPT-5-mini)
                                              </option>
                                              <option value="AzureGpt4">
                                                Azure OpenAI (gpt-4o-mini)
                                              </option>
                                            </Input>
                                          </Colxx>
                                          {m?.versionGPT3 === '7' && (
                                            <Fragment>
                                              <Colxx md="7" className="my-2">
                                                <Label>Verbosity</Label>
                                                <Input
                                                  type="select"
                                                  name="verbosity"
                                                  value={m?.verbosity}
                                                  onChange={(e) =>
                                                    handleFeaturesNLPChange(e, index)
                                                  }
                                                  className="mt-1"
                                                >
                                                  <option value="">Select</option>
                                                  <option value="low">Low</option>
                                                  <option value="medium">Medium</option>
                                                  <option value="high">High</option>
                                                </Input>
                                              </Colxx>
                                            </Fragment>
                                          )}
                                        </div>
                                      </Colxx>
                                    </Card>
                                  </Fragment>
                                )}
                            </Row>
                            <Row className="">
                              {m?.openAIAssistantList &&
                                m?.openAIAssistantList.length > 0 &&
                                m?.nlpType === 'openAIAssistant' && (
                                  <Fragment>
                                    <Card className="mb-3 mx-3">
                                      <Colxx xxs="12" className="py-2 px-0">
                                        <div className="">
                                          <Colxx md="12" className="my-2">
                                            Conversation flows are useful to provide more detailed, step-by-step 
                                            instructions to guide a customer through a process or task until completion.
                                          </Colxx>
                                          {m?.nlpType === 'openAIAssistant' && (
                                            <Fragment>
                                              <Colxx md="12" className="my-2">
                                                {m?.openAIAssistantList.map((p, oIndex) => {
                                                  const assistantRecord =
                                                    propetyAssistants?.find(
                                                      (assist) =>
                                                        assist?.id == p?.assistantId
                                                    );
                                                  const isNavigateToConversationFlow =
                                                    assistantRecord?.isGroupLevel == true
                                                      ? propertyId == '-1'
                                                      : propertyId != '-1';
                                                  return (
                                                    <Fragment>
                                                      {propetyAssistants.filter(
                                                        (f) =>
                                                          f?.id &&
                                                          f.id !== '' &&
                                                          f.pid == p.propertyId
                                                      ).length > 0 ? (
                                                        <Fragment>
                                                          <div className="mb-3">
                                                            <b
                                                              className="my-2 ml-1"
                                                              style={{ width: '20%', color: '#777' }}
                                                            >
                                                              {
                                                                propetyAssistants.filter(
                                                                  (f) =>
                                                                    f?.id &&
                                                                    f.id !== '' &&
                                                                    f.pid == p.propertyId
                                                                )[0]?.pname
                                                              }
                                                            </b>
                                                            <div
                                                              style={{ width: '100%' }}
                                                              className="my-2"
                                                            >
                                                              <Input
                                                                className="border p-2"
                                                                type="select"
                                                                name="assistantId"
                                                                placeholder="Dynamic Conversation Flow"
                                                                value={p?.assistantId}
                                                                onChange={(event) =>
                                                                  handleOpenAIAssistant(
                                                                    event,
                                                                    index,
                                                                    oIndex
                                                                  )
                                                                }
                                                              >
                                                                <option value="">
                                                                  Select a Dynamic Conversation Flow for{' '}
                                                                  {
                                                                    propetyAssistants.filter(
                                                                      (f) =>
                                                                        f?.id &&
                                                                        f.id !== '' &&
                                                                        f.pid ==
                                                                        p.propertyId
                                                                    )[0]?.pname
                                                                  }
                                                                </option>
                                                                {propetyAssistants
                                                                  .filter(
                                                                    (f) =>
                                                                      f?.id &&
                                                                      f.id !== '' &&
                                                                      f.pid == p.propertyId
                                                                  )
                                                                  .map((assist, index) => {
                                                                    return (
                                                                      <option
                                                                        key={index}
                                                                        value={assist.id}
                                                                      >
                                                                        {assist.isGroupLevel
                                                                          ? `${assist.name} (${assist.id}) (Group Level)`
                                                                          : `${assist.name} (${assist.id})`}
                                                                      </option>
                                                                    );
                                                                  })}
                                                              </Input>
                                                              {p?.assistantId &&
                                                                isNavigateToConversationFlow && (
                                                                  <div className="mt-2 ml-1">
                                                                    <a
                                                                      href={`/app/pages/propinfo/recommender?assistantId=${p?.assistantId}`}
                                                                      target="_self"
                                                                      rel="noopener noreferrer"
                                                                      style={{
                                                                        color: 'red',
                                                                        textDecoration:
                                                                          'underline',
                                                                        fontSize: '13px',
                                                                      }}
                                                                    >
                                                                      Go to conversation flow
                                                                    </a>
                                                                  </div>
                                                                )}
                                                            </div>
                                                          </div>
                                                        </Fragment>
                                                      ) : (
                                                        <div className="mb-3">
                                                         <b
                                                              className="my-2 ml-1"
                                                              style={{ width: '20%', color: '#777' }}
                                                            >
                                                            {propetyAssistants?.[0]?.pname}
                                                          </b>
                                                          <div
                                                            style={{ width: '100%' }}
                                                            className="my-2"
                                                          >
                                                            <Input
                                                              className="border-red p-2"
                                                              type="select"
                                                              name="assistantId"
                                                              placeholder="Dynamic Conversation Flow"
                                                              value={p?.assistantId}
                                                              onChange={(event) =>
                                                                handleOpenAIAssistant(
                                                                  event,
                                                                  index,
                                                                  oIndex
                                                                )
                                                              }
                                                            >
                                                              <option value="">
                                                                Select a Dynamic Conversation Flow for{' '}
                                                                {
                                                                  propetyAssistants?.[0]
                                                                    ?.pname
                                                                }
                                                              </option>
                                                            </Input>
                                                            {p?.assistantId &&
                                                              isNavigateToConversationFlow && (
                                                                <div className="mt-2 ml-1">
                                                                  <a
                                                                    href={`/app/pages/propinfo/recommender?assistantId=${p?.assistantId}`}
                                                                    target="_self"
                                                                    rel="noopener noreferrer"
                                                                    style={{
                                                                      color: 'red',
                                                                      textDecoration:
                                                                        'underline',
                                                                      fontSize: '13px',
                                                                    }}
                                                                  >
                                                                    Go to conversation flow
                                                                  </a>
                                                                </div>
                                                              )}
                                                          </div>
                                                        </div>
                                                      )}
                                                    </Fragment>
                                                  );
                                                })}
                                              </Colxx>
                                            </Fragment>
                                          )}
                                          {/* {m?.nlpType === 'openAIAssistant' && (
                                            <Colxx md="7" className="my-2">
                                              <Button
                                                variant="contained"
                                                color="primary"
                                                outline
                                                size="xs"
                                                onClick={() =>
                                                  window.open(
                                                    '/app/pages/propinfo/recommender',
                                                    '_blank'
                                                  )
                                                }
                                              >
                                                Create a New Flow
                                              </Button>
                                            </Colxx>
                                          )} */}
                                        </div>
                                      </Colxx>
                                    </Card>
                                  </Fragment>
                                )}
                            </Row>
                            <Row className="">
                              {m?.properties &&
                                m?.properties.length > 0 &&
                                m?.autoLanguageDetection === true && (
                                  <Fragment>
                                    <Card className="mb-3 mx-3">
                                      <Colxx xxs="12" className="py-2 px-0">
                                        <div className="">
                                          <Colxx md="12" className="mt-2">
                                            <Label>
                                              <b>
                                                Language Instructions (Optional, Gen AI
                                                Only)
                                              </b>
                                            </Label>
                                          </Colxx>
                                          <Colxx md="12">
                                            {' '}
                                            You can use this prompt to help an AI Chatbot
                                            translate text, giving it clear instructions on
                                            how to handle specific, unique words. Only used
                                            with the Gen AI option.
                                          </Colxx>
                                          <Colxx md="12" className="my-2">
                                            <Input
                                              className="mt-2"
                                              type="textarea"
                                              rows="3"
                                              name="languageInstructions"
                                              value={m?.languageInstructions}
                                              onChange={(event) =>
                                                handleFeaturesNLPChange(event, index)
                                              }
                                            />
                                          </Colxx>
                                        </div>
                                      </Colxx>
                                    </Card>
                                  </Fragment>
                                )}
                            </Row>
                            <Row className="">
                              {m?.properties &&
                                m?.properties.length > 0 &&
                                m?.imageRecognition === true && (
                                  <Fragment>
                                    <Card className="mb-3 mx-3">
                                      <Colxx xxs="12" className="py-2 px-0">
                                        <div className="">
                                          <Colxx md="12" className="mt-2">
                                            <Label>
                                              <b>Image Instructions (Optional)</b>
                                            </Label>
                                          </Colxx>
                                          <Colxx md="12" className="mb-2">
                                            {' '}
                                            You can use this prompt to help an AI Chatbot to
                                            search images, giving it clear instructions on
                                            how to handle specific, unique words.
                                          </Colxx>
                                          <Colxx md="12" className="my-2">
                                            <Input
                                              className="mt-2"
                                              type="textarea"
                                              name="imageInstructions"
                                              rows="3"
                                              value={m?.imageInstructions}
                                              onChange={(event) =>
                                                handleFeaturesNLPChange(event, index)
                                              }
                                            />
                                          </Colxx>
                                        </div>
                                      </Colxx>
                                    </Card>
                                  </Fragment>
                                )}
                            </Row>
                            {channel === 'whatsapp' && (
                              <Row className="">
                                <div className="mb-1 ml-2 text-left">
                                  <b>Choose Languages</b>
                                  <br />
                                  <Row className="mt-2">
                                    {console.error(m?.languageGPT3, 'languageGPT3')}
                                    {Languages.map((elem) => (
                                      <Colxx xxs="4">
                                        <CustomInput
                                          key={`${index}_checkbox_${elem.code}`}
                                          type="checkbox"
                                          value={elem.code}
                                          onChange={(e) =>
                                            handleLanguageChange(index, e)
                                          }
                                          checked={m?.languageGPT3.includes(
                                            elem.code
                                          )}
                                          className="text-left"
                                        >
                                          {elem?.name}
                                        </CustomInput>
                                      </Colxx>
                                    ))}
                                  </Row>
                                </div>
                              </Row>
                            )}
                          </Fragment>
                        )}
                        <Colxx xxs="12" className="text-right p-0">
                          <Button
                            color="danger"
                            outline
                            size="xs"
                            onClick={() => handleRemoveSettings(index)}
                          >
                            Remove Property Settings
                          </Button>
                        </Colxx>
                      </Fragment>
                    ))}
                </Colxx>
                {handleRecentProperties(allProperties).length > 0 && (
                  <Fragment>
                    <Button
                      className='mb-2'
                      color="primary"
                      outline
                      size="xs"
                      onClick={handleAddFeaturesList}
                    >
                      + Add Property Settings
                    </Button>
                  </Fragment>
                )
                }
              </div>
            </Colxx>
          </Card>
          <Separator className="my-3" />
          <div className="text-center mt-4 mb-2">
            <Button color="primary" size="xs" onClick={handleSave}>
              Save
            </Button>
          </div>
        </CardBody>
      </Card >
    </Fragment >
  );
}

export default ChatbotFeatures;
